let apiUrl = {

  userRegister: "/register/user",
  userLogin: "/auth/login",
  forgotPassword: "/password/reset",
  //myInvestment: "/dashboard/myinvestment",
};

export default apiUrl;
